import {fetchEquipmentRooms, fetchFloorEquipmentStandards} from '../../utils/equipment'
import {showMarker, removeAllMarkers} from '../../components/Drawing/hooks/useMarker'
import React, {useRef, useEffect, useReducer, useState} from 'react'
import { useReactToPrint } from 'react-to-print';
import Drawing from '../../components/Drawing/Drawing'
import DepartmentList from '../../components/DepartmentList/DepartmentList'
import Modal from 'react-modal'
import FloorRoomPrompt from '../../components/FloorRoomPrompt/FloorRoomPrompt'
import Icons from '../../components/Icons'
import Image from '../Detail/Image/Image'
import styled from 'styled-components'
import {fetchRoomsByDepartment, fetchRoomTypesToHighlight} from '../../api/room'
import {useUIState} from '../../context/UIContext'
import {select, event, remove} from 'd3-selection'
import {
  setDrawingHighlights,
  useDrawingDispatch,
  setDrawingShowMarker,
  useDrawingState
} from '../../context/DrawingContext'
import {_L, useLocaleState} from '../../context/LocaleContext'

const ReactModalAdapter = ({className, ...props}) => {
  const contentClassName = `${className}__content`
  const overlayClassName = `${className}__overlay`
  return (
    <Modal
      portalClassName={className}
      className={contentClassName}
      overlayClassName={overlayClassName}
      {...props}
    />
  )
}

const famText = "UIUC Facility Access Maps"
const dateText = new Date().toLocaleDateString("en-us", { year: 'numeric', month: 'long', day: 'numeric'})
const toggleLayerList = []
	toggleLayerList.push("layer-ROUTES")
	toggleLayerList.push("layer-TEXT-ADA")
	toggleLayerList.push("layer-TEXT-ADA-text")
let allOrNone = "none"
let layDisplay = "none"
let layTogTitle = "Show Unmarked Floor Plan"
let currEqStds = []
let currUses = {}
let useHighlightCount = 0
let showMarkerCount = 0
let currUse = null
let svgScale = 1

let currentBl = null
let currentFl = null

const initialState = {
  departmentsByFloor: {},
  roomTypesByFloor: {},
  eqStdsByFloor: {},
  eqForFloor: {}
}

const reducer = (state, action) => {
  if (action.type === 'setData') {
    return {
      ...state,
      ...action.payload
    }
  } else {
    throw new Error('Unexpected action')
  }
}

const highlightDepartments = ({
  drawingDispatch,
  departments,
  show,
  reset = false
}) => {
  let highlights = {}
  Object.values(departments).map(department => {
    const {dv_id, dp_id, color, rooms} = department
    if (dv_id && dp_id) {
      rooms.forEach(room => {
        highlights[room] = {
          stroke: color.text,
          fill: color.button,
          strokeWidth: '0.3%'
        }
      })
    }
  })
  setDrawingHighlights({
    dispatch: drawingDispatch,
    assetType: 'rm',
    highlights,
    show,
    reset
  })
}

const highlightUses = ({
  drawingDispatch,
  uses,
  show,
  reset = false
}) => {
  let highlights = {}
  Object.values(uses).map(use => {
    const {rmType, color, rooms} = use
    if (rmType) {
      rooms.forEach(room => {
        highlights[room] = {
          stroke: color.text,
          fill: color.button,
          strokeWidth: '0.1%'
        }
      })
    }
  })
  setDrawingHighlights({
    dispatch: drawingDispatch,
    assetType: 'rm',
    highlights,
    show,
    reset
  })
}

const markEq = ({
	activeFloor,
	svgElement,
	equips
}) => {
	let elementId = null
	let marker = null
	let eqDesc = null
	if (equips[0]) {
		equips.forEach(room => {
			if (room.rmId) {
				elementId = activeFloor.blId + ';' + activeFloor.flId + ';' + room.rmId
			}
			else {
				elementId = room.eqId
			}
			marker = {show: true, elementId: elementId, url: room.url, eqId: room.eqId}
			eqDesc = room.stdDescription
			showMarker({marker, svgElement, eqDesc, svgScale})
		})
		if (svgScale == 1 && document.getElementById("viewer") && document.querySelectorAll('[id^="outer_g"]')[0]) {
			let currMarkerH = document.querySelectorAll('[id^="outer_g"]')[0].getBoundingClientRect().height
			let kioskElement = document.querySelectorAll("*[class^=\"Kiosk__StyledContent\"]")[0]
			let kioskH = kioskElement.getBoundingClientRect().height
			let targetH = (40.0 * kioskH) / 757
			svgScale = targetH / currMarkerH
			equips.forEach(room => {
				if (room.rmId) {
					elementId = activeFloor.blId + ';' + activeFloor.flId + ';' + room.rmId
				}
				else {
					elementId = room.eqId
				}
				marker = {show: true, elementId: elementId, url: room.url, eqId: room.eqId}
				eqDesc = room.stdDescription
				showMarker({marker, svgElement, eqDesc, svgScale})
			})
		}
	}
}

const FloorPlan = ({
  showDepartmentList,
  promptContents = null,
  onRoomClick,
  onMyLocation,
  title,
  highlightAssets
}) => {
	
	const handlePrint = useReactToPrint({
		content: () => document.getElementById("FloorPlan"),
		onBeforeGetContent: () => {
			if (currUses && Object.keys(currUses).length == 0 && currEqStds && currEqStds.length == 0) {
				document.getElementById("Legend").style.display = "none"
				document.getElementById("FloorPlan").style.gridTemplateColumns = "1fr"
			}
			const bldgName = document.getElementById("BldgName")
			if (activeFloor && bldgName) { document.getElementById("FloorPlanTitleText").innerHTML = bldgName.innerHTML.replace("[", "(").replace("]", ")") + " - Floor " + activeFloor.flId }
//			if (activeFloor && document.title) { document.getElementById("FloorPlanTitleText").innerHTML = document.title.replace("UIUC Facility Access Maps | ", "") + " | Floor " + activeFloor.flId }
//			if (activeFloor && document.title) { document.getElementById("FloorPlanTitleText").innerHTML = document.title + " | Floor " + activeFloor.flId }
		},
		onAfterPrint: () => {
			if (document.getElementById("Legend").style.display == "none") {
				document.getElementById("Legend").style.display = ""
				document.getElementById("FloorPlan").style.gridTemplateColumns = "1fr 20%"
			}
			document.getElementById("FloorPlanTitleText").innerHTML = ""
		}
	});
  const localeState = useLocaleState()
  const [state, dispatch] = useReducer(reducer, initialState)
  const [showBookingPrompt, setShowBookingPrompt] = useState({
    show: false,
    room: {},
    position: {x: 0, y: 0}
  })

  const [hideDepartmentLegend, setHideDepartmentLegend] = useState(true)

  const uiState = useUIState()
  const drawingDispatch = useDrawingDispatch()
  const drawing = useDrawingState()
  
  if (drawing.status.flId && (!currentFl || currentFl != drawing.status.flId || !currentBl || currentBl != drawing.status.blId)) {
	currentFl = drawing.status.flId
	currentBl = drawing.status.blId
	let eqstdButtons = document.querySelectorAll("*[id^=\"legendEqStdButton\"]")
	eqstdButtons.forEach(function (btn) {btn.parentElement.classList.remove("button-print")})
	eqstdButtons.forEach(function (btn) {btn.style.removeProperty("background")})
	eqstdButtons.forEach(function (btn) {btn.ariaPressed = true})
	let rmtypeButtons = document.querySelectorAll("*[id^=\"legendRmTypeButton\"]")
	rmtypeButtons.forEach(function (btn) {btn.parentElement.classList.remove("button-print")})
	rmtypeButtons.forEach(function (btn) {btn.style.removeProperty("background")})
	rmtypeButtons.forEach(function (btn) {btn.style.removeProperty("color")})
	rmtypeButtons.forEach(function (btn) {btn.style.removeProperty("border-color")})
	rmtypeButtons.forEach(function (btn) {btn.ariaPressed = true})
	let toggleButton = document.getElementById("toggleAllButton")
	if (toggleButton) {
		toggleButton.innerHTML = "Turn All Off"
	}
	allOrNone = "none"		
	layDisplay = "none"
	layTogTitle = "Show Unmarked Floor Plan"
  }

  const {activeFloor, kioskId} = uiState
  svgScale = 1

  const {departmentsByFloor} = state
  const {roomTypesByFloor} = state
  const {eqStdsByFloor} = state
  const {eqForFloor} = state
  
  const svgElement = document.querySelectorAll("*[class^=\"Drawing__SvgContainer\"]")[0]
  
  useEffect(() => {
    setHideDepartmentLegend(window.innerWidth < 1024)
  }, [])

		  /*
  useEffect(
    () => {
      if (showDepartmentList) {
        fetchRoomsByDepartment(activeFloor).then(departmentsByFloor => {
          dispatch({
            type: 'setData',
            payload: {
              departmentsByFloor
            }
          })
          highlightDepartments({
            drawingDispatch,
            departments: departmentsByFloor,
            show: true
          })
        })
      }
    },
    [activeFloor, drawingDispatch, showDepartmentList]
  )
*/
  let rmtypeButtons = document.querySelectorAll("*[id^=\"legendRmTypeButton\"]")

	useEffect(
		() => {
			if (showDepartmentList) {
				fetchRoomTypesToHighlight(activeFloor).then(roomTypesByFloor => {
					dispatch({
						type: 'setData',
						payload: {
							roomTypesByFloor
						}
					})
					highlightUses({
						drawingDispatch,
						uses: roomTypesByFloor,
						show: true
					})
					currUses = {}
					currUses = Object.assign(currUses, roomTypesByFloor)
				})
			}
		},
		[activeFloor, drawingDispatch, showDepartmentList]
	)
  
	useEffect(
		() => {
			if (showDepartmentList) {
				fetchFloorEquipmentStandards({blId: activeFloor.blId, flId: activeFloor.flId}).then(eqStdsByFloor => {
					dispatch({
						type: 'setData',
						payload: {
							eqStdsByFloor
						}
					})
					currEqStds= []
					eqStdsByFloor.forEach(function (value) {
						currEqStds.push(value.eqStd)
					})
				})
			}
		},
		[activeFloor, drawingDispatch, showDepartmentList]
	)
	
    useEffect(
		() => {
			if (showDepartmentList && activeFloor.blId && activeFloor.flId) {
				fetchEquipmentRooms({blId: activeFloor.blId, flId: activeFloor.flId}).then(eqForFloor => {
					dispatch({
						type: 'setData',
						payload: {
						eqForFloor
						}
					})
					markEq({
						activeFloor,
						svgElement,
						equips: eqForFloor
					})
				})
			}
		},
		[activeFloor, showDepartmentList, svgElement]
    )
  
  const onHighlightClick = ({room, position}) => {
    onRoomClick({room})
    setShowBookingPrompt({show: true, room, position})
  }
// controls what happens when Department Button is clicked
  const onShowDepartmentList = () => 
    setHideDepartmentLegend(!hideDepartmentLegend)

  const highlightDepartment = (dv_id, dp_id) => {
    let departments = {}
    const departmentCode = dv_id + '|' + dp_id
    Object.keys(departmentsByFloor).filter(key => {
      if (key === departmentCode) {
        departments[key] = {...departmentsByFloor[key]}
      }
    })
    highlightDepartments({
      drawingDispatch,
      departments,
      show: true,
      reset: true
    })
  }

  const highlightUse = (rmType) => {
	useHighlightCount = Object.keys(currUses).length
    const isCurrUse = Object.keys(currUses).includes(rmType)
	if (isCurrUse) {
		delete currUses[rmType]
		document.getElementById("legendRmTypeButton"+rmType).parentElement.classList.add("button-print")
		document.getElementById("legendRmTypeButton"+rmType).style.background = "white"
		document.getElementById("legendRmTypeButton"+rmType).style.color = "black"
		document.getElementById("legendRmTypeButton"+rmType).style.borderColor = "#CCCCCC"
		document.getElementById("legendRmTypeButton"+rmType).ariaPressed = false
		allOrNone = "all"
		document.getElementById("toggleAllButton").innerHTML = "Turn All On"
	}
	else if (useHighlightCount > 0 || (useHighlightCount == 0 && Object.keys(roomTypesByFloor).length > 0)) {
		currUses[rmType] = roomTypesByFloor[rmType]
		document.getElementById("legendRmTypeButton"+rmType).parentElement.classList.remove("button-print")
		document.getElementById("legendRmTypeButton"+rmType).style.removeProperty("background")
		document.getElementById("legendRmTypeButton"+rmType).style.removeProperty("color")
		document.getElementById("legendRmTypeButton"+rmType).style.removeProperty("border-color")
		document.getElementById("legendRmTypeButton"+rmType).ariaPressed = true
		if (Object.keys(currUses).length == Object.keys(roomTypesByFloor).length && currEqStds.length == eqStdsByFloor.length) {
			allOrNone = "none"
			document.getElementById("toggleAllButton").innerHTML = "Turn All Off"
		}
	}
	useHighlightCount = Object.keys(currUses).length

    highlightUses({
      drawingDispatch,
      uses: currUses,
      show: true,
      reset: true
    })
	
	document.getElementById("legendRmTypeButton"+rmType).focus()
  }
  
  const showEqStd = (eqStd) => {
	let svgElement = document.querySelectorAll("*[class^=\"Drawing__SvgContainer\"]")[0]
	showMarkerCount = currEqStds.length
	if (eqStd == "toggle") {
		let eqstdButtons = document.querySelectorAll("*[id^=\"legendEqStdButton\"]")
		let rmtypeButtons = document.querySelectorAll("*[id^=\"legendRmTypeButton\"]")
		if (allOrNone == "all") {
			currUses = {}
			currUses = Object.assign(currUses, roomTypesByFloor)
			if (eqForFloor[0]) {
				markEq({
					activeFloor,
					svgElement,
					equips: eqForFloor
				})
			}
			highlightUses({
				drawingDispatch,
				uses: roomTypesByFloor,
				show: true,
				reset: true
			})
			allOrNone = "none"
			document.getElementById("toggleAllButton").innerHTML = "Turn All Off"
			currEqStds= []
			eqStdsByFloor.forEach(function (value) {
				currEqStds.push(value.eqStd)
			})
			eqstdButtons.forEach(function (btn) {btn.parentElement.classList.remove("button-print")})
			eqstdButtons.forEach(function (btn) {btn.style.removeProperty("background")})
			eqstdButtons.forEach(function (btn) {btn.ariaPressed = true})
			rmtypeButtons.forEach(function (btn) {btn.parentElement.classList.remove("button-print")})
			rmtypeButtons.forEach(function (btn) {btn.style.removeProperty("background")})
			rmtypeButtons.forEach(function (btn) {btn.style.removeProperty("color")})
			rmtypeButtons.forEach(function (btn) {btn.style.removeProperty("border-color")})
			rmtypeButtons.forEach(function (btn) {btn.ariaPressed = true})
		}
		else {
			currUses = {}
			if (svgScale == 1) {
				if (eqForFloor[0]) {
					markEq({
						activeFloor,
						svgElement,
						equips: eqForFloor
					})
				}
			}
			removeAllMarkers({svgElement})
			highlightUses({
				drawingDispatch,
				uses: roomTypesByFloor,
				show: false,
				reset: true
			})
			allOrNone = "all"
			document.getElementById("toggleAllButton").innerHTML = "Turn All On"
			currEqStds = []
			eqstdButtons.forEach(function (btn) {btn.parentElement.classList.add("button-print")})
			eqstdButtons.forEach(function (btn) {btn.style.background = "white"})
			eqstdButtons.forEach(function (btn) {btn.ariaPressed = false})
			rmtypeButtons.forEach(function (btn) {btn.parentElement.classList.add("button-print")})
			rmtypeButtons.forEach(function (btn) {btn.style.background = "white"})
			rmtypeButtons.forEach(function (btn) {btn.style.color = "black"})
			rmtypeButtons.forEach(function (btn) {btn.style.borderColor = "#CCCCCC"})
			rmtypeButtons.forEach(function (btn) {btn.ariaPressed = false})
		}
	}
	else {
		if (svgScale == 1) {
			if (eqForFloor[0]) {
				markEq({
					activeFloor,
					svgElement,
					equips: eqForFloor
				})
			}
		}
		removeAllMarkers({svgElement})
		const isCurrEqStd = currEqStds.includes(eqStd)
		if (isCurrEqStd) {
			currEqStds = currEqStds.filter(function(x, i) { return (x != eqStd) } )
			document.getElementById("legendEqStdButton"+eqStd).parentElement.classList.add("button-print")
			document.getElementById("legendEqStdButton"+eqStd).style.background = "white"
			document.getElementById("legendEqStdButton"+eqStd).ariaPressed = false
			allOrNone = "all"
			document.getElementById("toggleAllButton").innerHTML = "Turn All On"
			if (Object.keys(currUses).length == 0 && currEqStds.length == 0) {
			}
		}
		else if (showMarkerCount > 0 || (showMarkerCount == 0 && eqStdsByFloor.length > 0)) {
			currEqStds.push(eqStd)
			document.getElementById("legendEqStdButton"+eqStd).parentElement.classList.remove("button-print")
			document.getElementById("legendEqStdButton"+eqStd).style.background = "#CCCCCC"
			document.getElementById("legendEqStdButton"+eqStd).ariaPressed = true
			if (Object.keys(currUses).length == Object.keys(roomTypesByFloor).length && currEqStds.length == eqStdsByFloor.length) {
				allOrNone = "none"
				document.getElementById("toggleAllButton").innerHTML = "Turn All Off"
			}
		}
		showMarkerCount = currEqStds.length
		if (showMarkerCount > 0) {
			let equips = eqForFloor.filter(function(v, i) { return (currEqStds.includes(v.eqStd)) } )
			if (equips[0]) {
				markEq({
					activeFloor,
					svgElement,
					equips: equips
				})
			}
		}
	}
  }
  
  const handleCloseModal = () =>
    setShowBookingPrompt({show: false, room: {}, position: {x: 0, y: 0}})

  const {show, position} = showBookingPrompt

  const {marker, highlights} = drawing
  
  const onKeyDown = evt =>{
	  if(evt.key =='Enter'){
		  evt.currentTarget.click()
	  }
  }
  
  const copyLink = () => {
	if (activeFloor) {
		const floorPlanLink = window.location.origin+window.location.pathname+"?blId="+activeFloor.blId+"&flId="+activeFloor.flId
		navigator.clipboard.writeText( floorPlanLink )
		document.getElementById("MsgContainer").innerHTML = "Floor plan link copied to clipboard."
		document.getElementById("MsgContainer").style.display = "block"
		setTimeout(closeMessage, 3000);
	}
	else {
		document.getElementById("MsgContainer").innerHTML = "Error generating link for this floor."
		document.getElementById("MsgContainer").style.display = "block"
		setTimeout(closeMessage, 3000);
	}
  }
  const closeMessage = () => {
	document.getElementById("MsgContainer").style.display = "none"
  }
  
  const handleLayer = (svgLayer) => {
	if (svgLayer != null){
		svgLayer.style.display = layDisplay
	}
  }	  
  
  const basicFloorPlan = () => {
	toggleLayerList.forEach(function (layr) {
		let layerEl = document.getElementById(layr)
		handleLayer (layerEl)
	})
	allOrNone = layDisplay == "none" ? "none" : "all"
	showEqStd("toggle")
	layDisplay = layDisplay == "none" ? "initial" : "none"
	layTogTitle = layDisplay == "none" ? "Show Unmarked Floor Plan" : "Show Marked Floor Plan and Legend"
  }
  
	const setPageSettings = () => {
	  return `@page { margin: 0.1in !important; size: landscape; }`;
//	  return "@page { margin: 0.5in 0.5in 0.5in 0.5in !important; size: landscape;}";
	};
	
	const logoUrl = document.URL.replace("index.html", "tmp/images/uiuc-logo-for-web-print-1255-326.png")

/* 
    <Container id="FloorPlan">
		<style type="text/css" media="print">{"\ @page {\ size: landscape;\ }\ "}</style>
		<style type="text/css" media="print">{"\
		  @page {\ size: landscape;\
		  margin: 0.5in;\ }\
		"}</style>
 */
 
  return (
    <Container id="FloorPlan">
		<style>{setPageSettings()}</style>
		<LinkContainer>
			<NavButton id="copyFloorPlanLink" title="Copy Floor Plan Link to Clipboard" onClick={copyLink} onKeyDown={onKeyDown}>
				<svg id="svg-copy-icon" height="24" viewBox="1 1 14 14" fill="#3e4044" stroke="#3e4044" stroke-width="0.5">
					<path d="M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1.002 1.002 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4.018 4.018 0 0 1-.128-1.287z"/>
					<path d="M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243L6.586 4.672z"/>
				</svg>
			</NavButton>
		</LinkContainer>
		<MessageContainer id="MsgContainer">
		</MessageContainer>
		<PrintContainer>
			<NavButton id="printFloorPlan" title="Print Floor Plan" onClick={handlePrint} onKeyDown={onKeyDown}>
				<svg id="svg-print-icon" height="24" viewBox="0 0 2048 2048" fill="#3e4044" stroke="#3e4044" stroke-width="48">
					<path id="svg-print-icon-path" d="M1920 768q26 0 49 10t41 27 28 41 10 50v896h-512v256H512v-256H0V896q0-26 10-49t27-41 41-28 50-10h384V0h1024v768h384zm-1280 0h768V128H640v640zm768 640H640v512h768v-512zm512-512H128v768h384v-384h1024v384h384V896zM320 1024q26 0 45 19t19 45q0 26-19 45t-45 19q-26 0-45-19t-19-45q0-26 19-45t45-19z"/>
				</svg>
			</NavButton>
		</PrintContainer>
		<LayTogContainer >
			<NavButton id="basicFloorPlan" title={layTogTitle} onClick={basicFloorPlan} onKeyDown={onKeyDown}>
				<svg id="svg-layer-icon" height="24" viewBox="0 0 421.59 421.59" fill="#3e4044" stroke="#3e4044" stroke-width="16">
					<path id="svg-layer-icon-path" d="M400.491,291.098l-58.865-36.976l58.864-36.971c2.185-1.372,3.511-3.771,3.511-6.351s-1.326-4.979-3.511-6.352l-58.865-36.977l58.862-36.973c2.185-1.373,3.511-3.771,3.511-6.351s-1.326-4.979-3.511-6.351L214.783,1.149c-2.438-1.532-5.54-1.532-7.979,0L21.1,117.796c-2.185,1.373-3.511,3.771-3.511,6.351c0,2.58,1.326,4.979,3.511,6.351l58.861,36.972l-58.859,36.978c-2.185,1.373-3.51,3.771-3.51,6.351c0,2.58,1.326,4.979,3.511,6.351l58.859,36.97l-58.859,36.979c-2.185,1.372-3.51,3.771-3.51,6.351c0,2.58,1.326,4.979,3.511,6.351l185.7,116.64c1.22,0.766,2.604,1.149,3.989,1.149s2.77-0.383,3.989-1.149L400.491,303.8c2.185-1.372,3.511-3.771,3.511-6.351C404.002,294.869,402.676,292.47,400.491,291.098z M39.189,124.147l171.605-107.79l171.604,107.79l-171.604,107.79L39.189,124.147z M39.191,210.798l54.869-34.471l112.744,70.818c1.219,0.766,2.604,1.149,3.989,1.149c1.385,0,2.77-0.383,3.989-1.149l112.742-70.817l54.875,34.47L210.792,318.582 L39.191,210.798z M210.792,405.232L39.191,297.448l54.87-34.472l112.742,70.814c1.22,0.766,2.604,1.149,3.989,1.149s2.77-0.383,3.989-1.149l112.744-70.812l54.876,34.47L210.792,405.232z"></path>
				</svg>
			</NavButton>
		</LayTogContainer>
	  <NavContainer>
			<NavButton id="zoomIn" title="Zoom In" onKeyDown={onKeyDown}>
				<svg height="24" viewBox="0 0 16 17">
					<path fill="#3e4044" fillRule="nonzero" d="M15.794 15.697l-3.735-3.874a7.042 7.042 0 0 0 1.868-4.785C13.887 3.123 10.777-.022 6.97 0 3.157-.03.04 3.118 0 7.038c.04 3.92 3.157 7.068 6.97 7.038a6.88 6.88 0 0 0 3.941-1.238l3.792 3.94a.753.753 0 0 0 1.067 0 .78.78 0 0 0 .024-1.08zM1.524 7.038c.035-3.06 2.47-5.513 5.446-5.488 2.975-.024 5.408 2.43 5.444 5.488-.036 3.058-2.47 5.512-5.444 5.488-2.976.025-5.411-2.428-5.446-5.488z"></path>
					<SvgLine x1="4" y1="7" x2="10" y2="7"></SvgLine>
					<SvgLine x1="7" y1="4" x2="7" y2="10"></SvgLine>
				</svg>
			</NavButton>
			<NavButton id="zoomOut" title="Zoom Out" onKeyDown={onKeyDown}>
				<svg height="24" viewBox="0 0 16 17">
					<path fill="#3e4044" fillRule="nonzero" d="M15.794 15.697l-3.735-3.874a7.042 7.042 0 0 0 1.868-4.785C13.887 3.123 10.777-.022 6.97 0 3.157-.03.04 3.118 0 7.038c.04 3.92 3.157 7.068 6.97 7.038a6.88 6.88 0 0 0 3.941-1.238l3.792 3.94a.753.753 0 0 0 1.067 0 .78.78 0 0 0 .024-1.08zM1.524 7.038c.035-3.06 2.47-5.513 5.446-5.488 2.975-.024 5.408 2.43 5.444 5.488-.036 3.058-2.47 5.512-5.444 5.488-2.976.025-5.411-2.428-5.446-5.488z"></path>
					<SvgLine x1="4" y1="7" x2="10" y2="7"></SvgLine>
				</svg>
			</NavButton>
			<NavButton id="zoomReset" title="Reset Zoom" onKeyDown={onKeyDown}>
				<svg height="24" viewBox="0 0 16 17">
					<SvgCircle cx="8" cy="8" r="4.5"/>
					<SvgLine x1="8" y1="3.5" x2="8" y2="0"></SvgLine>
					<SvgLine x1="8" y1="12.5" x2="8" y2="16"></SvgLine>
					<SvgLine x1="3.5" y1="8" x2="0" y2="8"></SvgLine>
					<SvgLine x1="12.5" y1="8" x2="16" y2="8"></SvgLine>
				</svg>
			</NavButton>
	  </NavContainer>
	  <LogoContainer>
	      <Image url={logoUrl} placeholder={false} />
	  </LogoContainer>
	  <TitleContainer id="FloorPlanTitle">
        <BldgFloorText id="FloorPlanTitleText"></BldgFloorText>
        <TitleText id="FAMText">{famText}</TitleText>
        <DateText id="dateText">{dateText}</DateText>
      </TitleContainer>
      <DrawingContainer
        activeFloor={activeFloor}
        onHighlightClick={onRoomClick ? onHighlightClick : null}
        marker={marker}
        highlightAssets={highlightAssets}
        highlights={highlights}
      />
      {showDepartmentList &&
        !hideDepartmentLegend && (
          <StyledDepartmentList
			eqstds={eqStdsByFloor}
            onEqStdTap={showEqStd}
            departments={roomTypesByFloor}
            onDepartmentTap={highlightUse}
          />
        )}
      <IconsContainer>
        {showDepartmentList && (
          <LegendIcon onClick={onShowDepartmentList}>
            <Icons icon="LEGEND" height="24" width="24" />
          </LegendIcon>
        )}
        {kioskId && (
          <LocationContainer>
            <LocationIcon onClick={onMyLocation}>
              <Icons icon="MY_LOCATION" color="#ffffff" />
            </LocationIcon>
            <LocationLabel>{_L({key: 'Location', localeState})}</LocationLabel>
          </LocationContainer>
        )}
      </IconsContainer>

      <StyledModal
        isOpen={show}
        ariaHideApp={false}
        shouldFocusAfterRender={false}
        onRequestClose={handleCloseModal}
        shouldCloseOnOverlayClick
        style={{
          content: {
            top: position.y,
            left: position.x
          }
        }}
      >
        <FloorRoomPrompt>{promptContents}</FloorRoomPrompt>
      </StyledModal>
    </Container>
  )
}

/* 
      {title && (
        <TitleContainer>
          <TitleText>{title}</TitleText>
        </TitleContainer>
      )}
 */
FloorPlan.defaultProps = {
  showDepartmentList: true,
  highlightAssets: [{assetType: 'rm'}],
  departmentsByFloor: {},
  roomTypesByFloor: {},
  eqStdsByFloor: {},
  eqForFloor: {}
}

export default FloorPlan

/*  print legend on same page */
const Container = styled.div`
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  position: relative;
  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: 1fr 20%;
  align-items: stretch;

  @media (max-width: 420px) {
    grid-template-columns: 1fr;
  }
  
}
`

/* 
  @media print {
	@page {
		size: landscape;
		margin: 0.5in;
	}
  }
 */
/*  print legend on separate page */
/* 
const Container = styled.div`
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  position: relative;
  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: 1fr 20%;
  align-items: stretch;

  @media (max-width: 420px) {
    grid-template-columns: 1fr;
  }

  @media print {
    grid-template-columns: 1fr;
  }
`
 */
const IconsContainer = styled.div`
  position: absolute;
  left: 28px;
  bottom: 26px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: end;
  @media print {
    display: none;
  }
`

const LegendIcon = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 200px;
  box-shadow: 0 10px 16px 0 rgba(0, 0, 0, 0.29);
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding-top: 0;
  padding-left: 4px;

  @media (max-width: 420px) {
    display: none;
  }
`

const LocationContainer = styled.div`
  display: flex;
  box-sizing: border-box;
  justify-content: flex-start;
  flex-wrap: wrap;
  align-items: center;
`

const LocationIcon = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 200px;
  box-shadow: 0 8px 33px 0 rgba(43, 153, 255, 0.51);
  background-color: #3395fe;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-top: 10px;
`

const LocationLabel = styled.div`
  display: none;
  color: #a4a9b7;
  font-weight: 600;
  font-size: 12px;
  padding: 16px;
`

const StyledModal = styled(ReactModalAdapter)`
  &__overlay {
    position: fixed;
    top: 80px;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(18, 21, 32, 0.65);
    z-index: 40;
  }

  &__content {
    position: fixed;
    top: 100px;
    left: 200px;
    width: 300px;
    height: 160px;
    background: transparent;
    display: flex;
    align-items: center;
    box-sizing: border-box;

    &:after {
      content: ' ';
      width: 0;
      height: 0;
      border-top: 12px solid transparent;
      border-left: 12px solid transparent;
      border-bottom: 12px solid white;
      border-right: 12px solid transparent;
      position: absolute;
      left: 50%;
      top: 0;
      margin-top: 0;
      margin-left: -12px;
    }
  }
`

const DrawingContainer = styled(Drawing)`
  width: 100%;
  height: 100%;
  grid-row: 1;
  grid-column: 1;
  
  @media print {
	  display: flex;
	  flex-direction: column;
	  justify-content: center;
	  padding-left: 60px;
  }
`

const StyledDepartmentList = styled(DepartmentList)`
  width: 100%;
  height: 100%;
  grid-row: 1;
  grid-column: 2;

  @media (max-width: 420px) {
    display: none;
  }
`
// place title at top left
/*
  top: 23px;
  @media print {
	  display: flex;
	  flex-direction: row;
  }
*/
// place title at top center
/*
  top: 23px;
  @media print {
	  display: flex;
	  flex-direction: row;
	  justify-content: center;
	  align-items: center;
  }
*/
// place title at bottom left
/*
  top: calc(100vh - 40px);
  @media print {
	  display: flex;
	  flex-direction: row;
  }
*/
// place title at bottom center
/*
  top: calc(100vh - 10px);
  @media print {
	  display: flex;
	  flex-direction: row;
	  justify-content: center;
	  align-items: center;
  }
*/

const LogoContainer = styled.div`
  width: 0px;
  height: 0px;
  position: absolute;
  z-index: 1;
  left: 10px;
  overflow: hidden;
  padding-left: 10px;
  
  bottom: 10px;
  @media print {
	  display: flex;
	  align-items: center;
	  justify-content: center;
	  width: 106px;
	  height: 24px;
  }
`

const TitleContainer = styled.div`
  position: absolute;
  z-index: 1;
  right: 10px;
  display: none;
  color: #505050;
  font-style: normal;
  font-weight: bold;
  text-align: right;
  padding-right: 10px;
  
  bottom: 10px;
  @media print {
	  display: flex;
	  flex-direction: column;
	  justify-content: right;
	  width: fit-content;
  }
`

const BldgFloorText = styled.div`
  font-size: 10px;
`

const DateText = styled.div`
  font-size: 8px;
`

const TitleText = styled.div`
  font-size: 10px;
`
/*
const TitleText = styled.div`
  color: #505050;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  padding-top: 2px;
  padding-bottom: 2px;
  padding-left: 8px;
  padding-right: 8px;
  border-top: solid;
  border-top-color: #505050;
  border-top-width: medium;
  border-bottom: solid;
  border-bottom-color: #505050;
  border-bottom-width: medium;
`
*/
const NavContainer = styled.div`
  position: absolute;
  left: 28px;
  top: 23px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: end;
  background: #eff0f3;
  z-index: 1;
  @media print {
    display: none;
  }
`

const NavButton = styled.button`
	width: 32;
	height: 34;
	padding: 3px 3px 0 3px;
	border: none;
	background: none;
	cursor: pointer;

	:focus {
		outline: 3px solid #FF9900 !important;
  }
`

const LinkContainer = styled.div`
  position: absolute;
  left: 28px;
  top: 123px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: end;
  background: #eff0f3;
  z-index: 1;
  @media print {
    display: none;
  }
`
const MessageContainer = styled.div`
  width: auto;
  position: absolute;
  left: 68px;
  top: 123px;
  z-index: 1;
  border: none;
  padding: 4px;
  outline: 3px solid #FF9900 !important;
  background: #eff0f3;
  color: #505050;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  display: none;
  
  @media print {
	  display: none;
  }
`

const PrintContainer = styled.div`
  position: absolute;
  left: 28px;
  top: 203px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: end;
  background: #eff0f3;
  z-index: 1;
  @media print {
    display: none;
  }
`

const LayTogContainer = styled.div`
  position: absolute;
  left: 28px;
  top: 163px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: end;
  background: #eff0f3;
  z-index: 1;
  @media print {
    display: none;
  }
`

const SvgLine = styled.line`
	stroke: rgb(255,0,0);
	stroke-width: 1;
`

const SvgCircle = styled.circle`
	stroke: rgb(255,0,0);
	stroke-width: 1.5;
	fill: none;
`
